import { render, staticRenderFns } from "./voice-room-list.vue?vue&type=template&id=455e82f0&scoped=true&"
import script from "./voice-room-list.vue?vue&type=script&lang=js&"
export * from "./voice-room-list.vue?vue&type=script&lang=js&"
import style0 from "./voice-room-list.vue?vue&type=style&index=0&id=455e82f0&lang=scss&scoped=true&"
import style1 from "./voice-room-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455e82f0",
  null
  
)

export default component.exports